import React from 'react'
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';
// import { ImportContactContainer } from './resident.style';

import ResidentListTableContainer from './widgets/resident_list_table'

function ResidentPageWidget() {

  return (
    <div className=''>
        <div className='row'>
            <br/>
            <div className='col s12 m3'>
                <PageTitleText>
                    Resident
                </PageTitleText>
            </div>
            
        </div>  
         
        {/* <AddResidentBtn/> */}

        {/* <ImportContactContainer/> */}
        
        <ResidentListTableContainer/>
       
    </div>
  )
}

export default ResidentPageWidget